import { render, staticRenderFns } from "./SBZC.vue?vue&type=template&id=54ceae9c&scoped=true&"
import script from "./SBZC.vue?vue&type=script&lang=js&"
export * from "./SBZC.vue?vue&type=script&lang=js&"
import style0 from "./SBZC.vue?vue&type=style&index=0&id=54ceae9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ceae9c",
  null
  
)

export default component.exports